import axios from '../axios'

/*
 * 人员管理模块
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/sysPerson/save',
    method: 'post',
    data
  })
};
// 编辑
export const edit = (data) => {
  return axios({
    url: '/sysPerson/edit',
    method: 'post',
    data
  })
};
// 查看
export const view = (data) => {
  return axios({
    url: '/sysPerson/view',
    method: 'post',
    data
  })
};
// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/sysPerson/delete',
    method: 'post',
    data
  });
};
// 分页查询
export const list = (data) => {
  return axios({
    url: '/sysPerson/list',
    method: 'post',
    data
  })
};





// WEBPACK FOOTER //
// ./src/http/moudules/person.js